<template>
    <form v-on:submit.prevent="onSubmit">
        <calculation-demand-information-form :simplified-form="this.simplifiedForm" ref="demandInfomrationForm"/>
        <p v-if="bimId">Ceny uvedené v kalkulaci jsou základní ceníkové, finální ceny určuje distributor.</p>
        <p>
            Odesláním souhlasíte se <a target="_blank" href="/ochrana-osobnich-udaju-poptavky-materialu/">zpracováním
            osobních údajů</a><br>za účelem vyřízení objednávky.
        </p>
        <error-state field="calculation.demand.information.request" v-if="error"/>
        <div class="basicForm__row basicForm__item">
            <input type="submit" class="button view-warning" :disabled="processing"
                   :value="processing ? 'Odesílám poptávku...' : 'Odeslat poptávku'"/>
        </div>
    </form>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import CalculationDemandInformationForm from './DemandInformationForm';
    import ErrorState from '../../error/ErrorState';
    import {createClientDemand} from '../api/calculator';
    import {pushGTM} from '../../../helpers/gtm';

    export default {
        name:       'CalculationDemandInformationFormContainer',
        components: {
            ErrorState,
            CalculationDemandInformationForm
        },
        data() {
            return {
                processing: false,
                error:      false,
            }
        },
        computed:   {
            ...mapGetters('calculation', ['requestParameters', 'bimId']),
            ...mapGetters('error', ['errors']),
        },
        props: {
            simplifiedForm: {
                type: Boolean,
                default: false,
            }
        },
        methods:    {
            ...mapActions('error', ['clearErrors', 'setError']),
            onSubmit() {
                this.validate();
                if (0 === this.errors.length) {
                    const requestData = this.requestParameters('shop');
                    this.processing = true;
                    createClientDemand(requestData)
                    .then((response) => {
                        null === requestData.constructionId ?
                            pushGTM('Shopping list - created', 'New shopping list - BIM') :
                            pushGTM('Shopping list - created', 'New shopping list');
                        this.$emit('calculation-demand-created', { requestData, response });
                    })
                    .catch(() => this.setError({
                        msg: 'Poptávku se nepodařilo odeslat, zkuste to, prosím, znovu.',
                        key: 'calculation.demand.information.request'
                    }))
                    .finally(() => this.processing = false);
                }
            },
            validate() {
                this.clearErrors();
                this.$refs.demandInfomrationForm.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandInformationFormContainer.vue